import { render, staticRenderFns } from "./FormTextQuestion.vue?vue&type=template&id=22473142"
import script from "./FormTextQuestion.vue?vue&type=script&lang=js"
export * from "./FormTextQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports